@if (loaded()) {
  <div class="uvSectionHead">
    <div class="recipientsTitle">
      <span class="title3">{{ title | translate }}</span>
      <span class="captionText secondaryTextColor">{{ (scope() === 'none' ? noneLabel : 'RECIPIENTS.SCOPE_' + (scope() | uppercase)) | translate }}</span>
    </div>

    @if (canEdit()) {
      <div class="uvActions">
        @if (dirty()) {
          <button mat-button type="button" class="btn outlineActionButton" [disabled]="saving()" (click)="discard()">
            {{ 'GENERAL.DISCARD_CHANGES' | translate }}
          </button>
        } @else if (scope() === 'device') {
          <button mat-button type="button" class="btn outlineActionButton" [disabled]="saving()" (click)="useDefault()">
            {{ 'RECIPIENTS.USE_DEFAULT' | translate }}
          </button>
        }
        <button mat-button type="button" class="btn actionButton" [disabled]="saving() || !dirty()" (click)="save()">
          {{ 'GENERAL.SAVE' | translate }}
        </button>
      </div>
    }
  </div>

  <urban-recipient-picker [value]="recipients()" [disabled]="!canEdit()" (valueChange)="onChange($event)">
  </urban-recipient-picker>

  @if (hint) {
    <p class="captionText secondaryTextColor mb-0">{{ hint | translate }}</p>
  }
}
